import React, { Suspense, useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Redirect,
  Route,
  Switch,
  useLocation,
  useHistory,
} from "react-router-dom";
import { CContainer, CFade } from "@coreui/react";
import { local } from "brownies";

// routes config
import routes from "../routes";
import {
  setUser,
  setRoles,
  setModules,
  setAuthenticated,
  setSidebarMenus,
} from "../redux/actions";
import http from "../config";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

const TheContent = (props) => {
  const [apicheck, setApicheck] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const route = ["/login", "/forgot-password", "/register", "/reset-password"];

  let url = "/login";
  let profileUrl = "/dashboard";

  const basicModules = async () => {
    try {
      let result = await http.get("/commons/basic-modules");
      const { roles, user, modules, menus } = result.data;
      props.setUser(user);
      props.setRoles(roles);
      props.setModules(modules);
      props.setSidebarMenus(menus);
      local.user = user;
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    handleAppSession();
  }, [location]);

  const handleAppSession = (loadBasicModules = false) => {
    let { access_token, expires_in, user } = local;

    if (user) {
      let end = new Date().getTime();
      let start = new Date(user.last_active).getTime();
      let sessionRemaining = end - start;
      const expires = expires_in * 60 * 1000;

      if (sessionRemaining > expires) {
        expirySession();
        sessionRemaining = 0;
        start = 0;
        return;
      }
    } else if (!access_token || !expires_in) {
      expirySession();
      return;
    }

    if (!apicheck && route.indexOf(history.location.pathname) === -1)
      checkApi();

    if (props.modules.length === 0) basicModules();
  };

  const expirySession = () => {
    local.isAuthenticated = false;
    local.expires_in = null;
    local.access_token = null;
    history.push(url);
  };

  const checkApi = async () => {
    try {
      setApicheck(true);
      let r = await http.get("/auth/check-authentication");
      let authenticated = r.data.authenticated;
      props.setAuthenticated(authenticated);
      local.isAuthenticated = authenticated;
      if (authenticated && route.indexOf(history.location.pathname) > -1) {
        redirection();
      }
      setApicheck(false);
    } catch (err) {
      console.error("not authenticated");
      expirySession();
      setApicheck(false);
    }
  };
  const redirection = (role) => {
    history.push(profileUrl);
  };
  return (
    <main className="c-main">
      <CContainer fluid>
        <Suspense fallback={loading}>
          <Switch>
            {routes.map((route, idx) => {
              return (
                route.component && (
                  <Route
                    key={idx}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    render={(props) => (
                      <CFade>
                        <route.component {...props} />
                      </CFade>
                    )}
                  />
                )
              );
            })}
            <Redirect from="/" to={profileUrl} />
          </Switch>
        </Suspense>
      </CContainer>
    </main>
  );
};
const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  user: state.auth.user,
  isAuthenticated: state.auth,
  modules: state.auth.modules,
});
export default connect(mapStateToProps, {
  setUser,
  setRoles,
  setModules,
  setAuthenticated,
  setSidebarMenus,
})(React.memo(TheContent));
